/*
  KÄLLA quiz engine. Reads its wording and scoring from window.KALLA_QUIZ
  (kalla-quiz-pms-copy.js) and its settings from the section's data attributes.

  Privacy: every answer stays in this browser. The only thing that leaves
  the page is the email address, sent to Klaviyo with marketing consent,
  followed by a Meta "Lead" event with a neutral label.
*/
(function () {
  "use strict";

  var root = document.querySelector("[data-pq]");
  var CFG = window.KALLA_QUIZ;
  if (!root || !CFG) return;

  var lang = (root.getAttribute("data-locale") || "").toLowerCase().indexOf("sv") === 0 ? "sv" : "en";
  var T = CFG.ui[lang];
  var SIGNALS = CFG.signals[lang];
  var QUESTIONS = CFG.questions.map(function (q) {
    var c = q[lang];
    return {
      id: q.id, type: q.type, sensitive: !!q.sensitive,
      title: c.title, sub: c.sub, note: c.sensitiveNote, why: c.why, src: c.src,
      options: c.options.map(function (o, i) { return { t: o.t, h: o.h, p: q.points[i] }; })
    };
  });
  var COUNT = QUESTIONS.length;
  var LETTERS = "ABCD";
  var SCHEME_INTRO = root.getAttribute("data-scheme-intro");
  var SCHEME_MAIN = root.getAttribute("data-scheme-main");
  var SCHEME_CARD = root.getAttribute("data-scheme-card");
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var NS = "http://www.w3.org/2000/svg";

  var state = { i: 0, answers: new Array(COUNT).fill(null), email: null, locked: false };

  function q$(sel) { return root.querySelector(sel); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function svgEl(tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }
  function scoreOf(a) { return a.reduce(function (s, x, i) { return s + (x == null ? 0 : QUESTIONS[i].options[x].p); }, 0); }
  function bandOf(score) { for (var i = 0; i < CFG.bands.length; i++) { if (score <= CFG.bands[i].max) return CFG.bands[i].key; } return "peri"; }

  /* ------------------------------------------------------------
     Colour schemes: the start screen uses its own scheme, the rest
     of the quiz the main one. Both come from the theme settings.
     ------------------------------------------------------------ */
  function setIntroScheme(on) {
    root.classList.remove(SCHEME_INTRO, SCHEME_MAIN);
    root.classList.add(on ? SCHEME_INTRO : SCHEME_MAIN);
    root.classList.toggle("pq-is-intro", on);
  }

  function colourOf(schemeClass, prop) {
    var probe = document.createElement("div");
    if (schemeClass) probe.className = schemeClass;
    probe.style.display = "none";
    root.appendChild(probe);
    var value = getComputedStyle(probe).getPropertyValue(prop).trim();
    probe.remove();
    return toRgb(value);
  }
  function toRgb(value) {
    var ctx = document.createElement("canvas").getContext("2d");
    ctx.fillStyle = "#000"; ctx.fillStyle = value || "#000";
    var s = ctx.fillStyle;
    if (s.charAt(0) === "#") return [parseInt(s.substr(1, 2), 16) / 255, parseInt(s.substr(3, 2), 16) / 255, parseInt(s.substr(5, 2), 16) / 255];
    var m = s.match(/[\d.]+/g) || [0, 0, 0];
    return [m[0] / 255, m[1] / 255, m[2] / 255];
  }

  /* ------------------------------------------------------------
     WORLD: one WebGL plane behind everything. Slow light on water,
     ripples on every choice, a dark spring for the start screen.
     Colours are read from the theme's colour schemes.
     ------------------------------------------------------------ */
  var World = (function () {
    var canvas = q$(".pq-world"), gl = null, loc = {}, start = performance.now();
    var ripples = [], dark = 1, darkFrom = 1, darkTarget = 1, darkT0 = 0, energy = 0, energyTarget = 0, lastDraw = 0, scale = 1;
    var none = { ripple: function () {}, setDark: function () {}, pulse: function () {} };
    if (!canvas) return none;
    try { gl = canvas.getContext("webgl", { antialias: false }); } catch (e) {}
    if (!gl) { canvas.remove(); return none; }

    var VS = "attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}";
    var FS = [
      "precision mediump float;",
      "uniform vec2 R;uniform float T;uniform float D;uniform float E;",
      "uniform vec3 CL;uniform vec3 CW;uniform vec3 CD;uniform vec3 CA;",
      "uniform vec4 RP[6];",
      "float h1(vec2 p){return fract(sin(dot(p,vec2(12.9898,78.233)))*43758.5453);}",
      "void main(){",
      " vec2 px=gl_FragCoord.xy; float t=T;",
      " vec2 disp=vec2(0.); float ring=0.;",
      " for(int k=0;k<6;k++){vec4 r=RP[k]; if(r.w>0.){float age=t-r.z; vec2 dv=px-r.xy; float d=length(dv); float rad=age*(220.+r.w*120.); float w=22.+age*26.;",
      "  float g=exp(-pow((d-rad)/w,2.))*exp(-age*1.4)*r.w; ring+=g; disp+=normalize(dv+.001)*g*14.;}}",
      " vec2 p=(px+disp)/R.y*2.6+vec2(3.,1.);",
      " for(int i=1;i<5;i++){float fi=float(i); p+=vec2(.55/fi*sin(fi*p.y+t*.23+.4*fi)+.6,.45/fi*sin(fi*p.x+t*.19+.7*fi)-.4);}",
      " float v=.5+.5*sin(p.x+p.y); float v2=.5+.5*sin(p.x*1.7-p.y*1.3+1.);",
      " float caus=pow(v,7.)*.8+pow(v2,9.)*.5;",
      " float breath=.5+.5*sin(t*.35);",
      " vec2 c=px/R; float blobA=smoothstep(.95,.0,length((c-vec2(.18+.06*sin(t*.11),.82))*vec2(1.,1.3)));",
      " float blobB=smoothstep(1.,.0,length((c-vec2(.86,.16+.05*cos(t*.13)))*vec2(1.,1.2)));",
      " vec3 light=mix(CL,CW,blobA*(.55+.25*breath)+blobB*.45);",
      " light+=vec3(1.)*caus*(.035+.03*E);",
      " light-=vec3(.012)*(1.-v)*(1.-blobA);",
      " vec3 dk=mix(CD,mix(CD,CW,.1),blobA*.8+blobB*.35);",
      " dk+=CW*caus*(.07+.03*breath);",
      " vec3 col=mix(light,dk,D);",
      " col=mix(col,mix(CA,vec3(1.),D*.6),clamp(ring,0.,1.)*.22);",
      " col+=(h1(px+fract(t)*91.)-.5)*.03;",
      " gl_FragColor=vec4(col,1.);}"
    ].join("\n");

    function shader(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; }
    var prog = gl.createProgram();
    gl.attachShader(prog, shader(gl.VERTEX_SHADER, VS));
    gl.attachShader(prog, shader(gl.FRAGMENT_SHADER, FS));
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { canvas.remove(); return none; }
    gl.useProgram(prog);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var aLoc = gl.getAttribLocation(prog, "a"); gl.enableVertexAttribArray(aLoc); gl.vertexAttribPointer(aLoc, 2, gl.FLOAT, false, 0, 0);
    ["R", "T", "D", "E", "CL", "CW", "CD", "CA", "RP"].forEach(function (n) { loc[n] = gl.getUniformLocation(prog, n); });

    var cl = colourOf(SCHEME_MAIN, "--color-background");
    var cw = colourOf(SCHEME_CARD, "--color-background");
    var cd = colourOf(SCHEME_INTRO, "--color-background");
    var ca = toRgb(getComputedStyle(root).getPropertyValue("--pq-accent").trim());
    gl.uniform3fv(loc.CL, cl); gl.uniform3fv(loc.CW, cw); gl.uniform3fv(loc.CD, cd); gl.uniform3fv(loc.CA, ca);

    function resize() {
      scale = Math.min(window.devicePixelRatio || 1, 1.5) * 0.6;
      canvas.width = Math.round(innerWidth * scale); canvas.height = Math.round(innerHeight * scale);
      gl.viewport(0, 0, canvas.width, canvas.height); draw(performance.now());
    }
    function draw(now) {
      var t = (now - start) / 1000;
      var k = Math.min(1, (now - darkT0) / 1100); k = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      dark = darkFrom + (darkTarget - darkFrom) * k;
      energy += (energyTarget - energy) * 0.06; energyTarget *= 0.97;
      var arr = new Float32Array(24);
      ripples = ripples.filter(function (r) { return t - r.t < 4; });
      ripples.slice(-6).forEach(function (r, i) { arr[i * 4] = r.x * scale; arr[i * 4 + 1] = (innerHeight - r.y) * scale; arr[i * 4 + 2] = r.t; arr[i * 4 + 3] = r.s; });
      gl.uniform2f(loc.R, canvas.width, canvas.height); gl.uniform1f(loc.T, reduced ? 4 : t);
      gl.uniform1f(loc.D, dark); gl.uniform1f(loc.E, energy); gl.uniform4fv(loc.RP, arr);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    function loop(now) { if (!document.hidden && now - lastDraw > 24) { draw(now); lastDraw = now; } requestAnimationFrame(loop); }
    addEventListener("resize", resize); resize();
    if (!reduced) requestAnimationFrame(loop);
    function nowT() { return (performance.now() - start) / 1000; }
    return {
      ripple: function (x, y, s) { if (reduced) return; ripples.push({ x: x, y: y, t: nowT(), s: s || 1 }); energyTarget = 1; },
      setDark: function (v) { darkFrom = dark; darkTarget = v; darkT0 = reduced ? -1e9 : performance.now(); if (reduced) draw(performance.now()); },
      pulse: function () { energyTarget = 1.6; }
    };
  })();

  /* ------------------------------------------------------------
     THE LINE: one wave per answer, drawn as one continuous line.
     More points toward perimenopause = a taller wave. Each wave
     starts at the height the previous one ended on.
     ------------------------------------------------------------ */
  function smoothPath(pts) {
    if (pts.length < 2) return "";
    var d = "M" + pts[0][0].toFixed(1) + " " + pts[0][1].toFixed(1);
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      d += " C" + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + " " + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) + "," +
        (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + " " + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) + "," +
        p2[0].toFixed(1) + " " + p2[1].toFixed(1);
    }
    return d;
  }
  function linePoints(answers, W, mid, maxAmp) {
    var pts = [[0, mid]], seg = W / COUNT, prev = maxAmp * 0.12, n = 24;
    for (var i = 0; i < answers.length; i++) {
      var a = answers[i]; if (a == null) break;
      var amp = maxAmp * (0.16 + 0.28 * QUESTIONS[i].options[a].p);
      for (var k = 1; k <= n; k++) {
        var t = k / n, e = t * t * (3 - 2 * t);
        pts.push([i * seg + seg * t, mid - (prev + (amp - prev) * e) * Math.sin(2 * Math.PI * t)]);
      }
      prev = amp;
    }
    return pts;
  }

  var Line = (function () {
    var wrap = q$(".pq-line"), svg = q$(".pq-line svg"), W, H, mid, ticks = [], soul, tip, tipRing, prevLen = 0;
    function answered() { return state.answers.filter(function (a) { return a != null; }).length; }
    function build() {
      W = innerWidth; H = wrap.clientHeight || 96; mid = H * 0.5;
      svg.setAttribute("viewBox", "0 0 " + W + " " + H); svg.innerHTML = ""; ticks = [];
      svgEl("line", { x1: 0, y1: mid, x2: W, y2: mid, "class": "pq-line__base" }, svg);
      for (var i = 0; i <= COUNT; i++) ticks.push(svgEl("line", { x1: (W / COUNT) * i, x2: (W / COUNT) * i, y1: mid - 5, y2: mid + 5, "class": "pq-line__tick" }, svg));
      soul = svgEl("path", { "class": "pq-line__soul", d: "M0 " + mid }, svg);
      tipRing = svgEl("circle", { "class": "pq-line__ring", cx: 0, cy: mid, r: 3, opacity: 0 }, svg);
      tip = svgEl("circle", { "class": "pq-line__tip", cx: 0, cy: mid, r: 2.5 }, svg);
      prevLen = 0; render(false);
    }
    function render(animate) {
      var d = smoothPath(linePoints(state.answers, W, mid, H * 0.36));
      soul.setAttribute("d", d || ("M0 " + mid));
      var len = d ? soul.getTotalLength() : 0, end = [(W / COUNT) * answered(), mid];
      ticks.forEach(function (t, i) { t.classList.toggle("is-now", i === state.i + 1 && state.i < COUNT); });
      soul.getAnimations().forEach(function (a) { a.cancel(); });
      if (animate && !reduced && len > prevLen) {
        soul.style.strokeDasharray = len;
        soul.animate([{ strokeDashoffset: len - prevLen }, { strokeDashoffset: 0 }], { duration: 1100, easing: "cubic-bezier(.65,.05,.25,1)", fill: "forwards" });
        var from = prevLen, t0 = performance.now();
        (function step(now) {
          var k = Math.min(1, (now - t0) / 1100), e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
          var pt = soul.getPointAtLength(from + (len - from) * e);
          tip.setAttribute("cx", pt.x); tip.setAttribute("cy", pt.y);
          if (k < 1) requestAnimationFrame(step);
          else { tip.setAttribute("cx", end[0]); tip.setAttribute("cy", end[1]); splash(); }
        })(t0);
      } else {
        soul.style.strokeDasharray = "";
        tip.setAttribute("cx", end[0]); tip.setAttribute("cy", end[1]);
      }
      prevLen = len;
    }
    function splash() {
      if (reduced) return;
      tipRing.setAttribute("cx", tip.getAttribute("cx")); tipRing.setAttribute("cy", tip.getAttribute("cy"));
      tipRing.animate([{ r: 2, opacity: .9 }, { r: 22, opacity: 0 }], { duration: 900, easing: "cubic-bezier(.2,.9,.25,1)" });
    }
    function target() { var r = svg.getBoundingClientRect(); return [r.left + Math.min((W / COUNT) * (state.i + 1), W - 8), r.top + mid]; }
    addEventListener("resize", function () { if (W !== innerWidth) build(); });
    return { build: build, render: render, target: target, show: function (v) { wrap.classList.toggle("is-on", v); } };
  })();

  /* ------------------------------------------------------------
     SCREENS
     ------------------------------------------------------------ */
  var stage = q$("[data-pq-stage]");
  var privacyUrl = root.getAttribute("data-privacy-url") || "";
  var ICON_PLUS = '<svg class="pq-plus" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M7 1v12M1 7h12"/></svg>';
  var ICON_LOCK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><rect x="3" y="7" width="10" height="7"/><path d="M5 7V5a3 3 0 0 1 6 0v2"/></svg>';
  var privacyLink = privacyUrl ? '<a class="link" href="' + esc(privacyUrl) + '" target="_blank" rel="noopener">' + esc(T.privacyLink) + '</a>' : "";
  var ICON_CLOSE = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M2 2l10 10M12 2 2 12"/></svg>';
  var HOME = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  function privacyBlock(extra) {
    return '<details class="pq-privacy' + (extra ? " " + extra : "") + '"><summary><span>' + ICON_LOCK + esc(T.privacyTitle) + '</span>' + ICON_PLUS + '</summary>' +
      '<div class="pq-privacy__body"><ul>' + T.privacy.map(function (l) { return "<li>" + esc(l) + "</li>"; }).join("") + '</ul>' + privacyLink + '</div></details>';
  }

  stage.innerHTML =
    '<section class="pq-screen pq-intro is-active" data-screen="intro" aria-labelledby="pq-intro-title">' +
      '<svg class="pq-intro__spring" viewBox="0 0 180 44" aria-hidden="true"><line x1="0" y1="22" x2="180" y2="22"/><path d="M0 22 C 15 22, 20 8, 35 8 S 55 36, 70 36 S 90 10, 105 10 S 125 32, 140 32 S 165 22, 180 22"/></svg>' +
      '<h1 class="h1" id="pq-intro-title">' + esc(T.introTitle) + '</h1>' +
      '<p class="pq-intro__text">' + esc(T.introText) + '</p>' +
      '<button class="btn pq-start" type="button" data-pq-start>' + esc(T.start) + '</button>' +
      '<p class="pq-intro__meta">' + esc(T.introMeta) + '</p>' +
      privacyBlock() +
    '</section>' +
    '<section class="pq-screen" data-screen="question" aria-live="polite"></section>' +
    '<section class="pq-screen" data-screen="email">' +
      '<div class="pq-capture ' + esc(SCHEME_CARD) + '">' +
        '<h2 class="h2">' + esc(T.gateTitle) + '</h2>' +
        '<p>' + esc(T.gateText) + '</p>' +
        '<form class="pq-form" novalidate data-pq-form>' +
          '<div class="field"><input class="field__input" type="email" id="pq-mail" name="email" autocomplete="email" placeholder="' + esc(T.emailLabel) + '" required><label class="field__label" for="pq-mail">' + esc(T.emailLabel) + '</label></div>' +
          '<p class="pq-err" role="alert" data-pq-err></p>' +
          '<button class="btn btn--full ' + esc(SCHEME_MAIN) + '" type="submit">' + esc(T.gateButton) + '</button>' +
          '<p class="pq-fine">' + esc(T.gateFine) + (privacyLink ? " " + privacyLink : "") + '</p>' +
        '</form>' +
      '</div>' +
    '</section>' +
    '<section class="pq-screen pq-analysing" data-screen="analysing" aria-live="polite"><svg viewBox="0 0 560 220" aria-hidden="true"></svg><p class="pq-analysing__msg"></p></section>' +
    '<section class="pq-screen pq-screen--wide pq-result" data-screen="result"></section>';

  var screens = {};
  ["intro", "question", "email", "analysing", "result"].forEach(function (k) { screens[k] = stage.querySelector('[data-screen="' + k + '"]'); });
  var backBtn = q$("[data-pq-back]"), counter = q$("[data-pq-count]"), counterNow = q$("[data-pq-count-now]");
  if (backBtn) backBtn.querySelector("span").textContent = T.back;
  if (counter) counter.querySelector("[data-pq-count-total]").textContent = ("0" + COUNT).slice(-2);

  function show(key) {
    Object.keys(screens).forEach(function (k) { screens[k].classList.toggle("is-active", k === key); });
    if (backBtn) backBtn.classList.toggle("is-on", (key === "question" && state.i > 0) || key === "email");
    if (counter) counter.classList.toggle("is-on", key === "question");
    window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
  }
  function leave(el, fn) {
    if (reduced || !el.classList.contains("is-active")) { fn(); return; }
    el.classList.remove("pq-enter"); el.classList.add("pq-leave");
    setTimeout(function () { el.classList.remove("pq-leave"); fn(); }, 260);
  }
  function enter(el) { el.classList.remove("pq-enter"); void el.offsetWidth; el.classList.add("pq-enter"); }

  /* ---------- questions ---------- */
  function renderQuestion() {
    var q = QUESTIONS[state.i], sel = state.answers[state.i], host = screens.question, html = "";
    if (counterNow) counterNow.textContent = ("0" + (state.i + 1)).slice(-2);
    html += '<h2 class="h2 pq-q__title" tabindex="-1">' + esc(q.title) + '</h2>';
    if (q.sub) html += '<p class="pq-q__sub">' + esc(q.sub) + '</p>';
    if (q.sensitive && q.note) html += '<p class="pq-sensitive">' + ICON_LOCK + '<span>' + esc(q.note) + '</span></p>';
    if (q.type === "scale") {
      html += '<div class="pq-scale' + (sel != null ? " has-value" : "") + '" role="radiogroup"><span class="pq-scale__fill"></span>';
      q.options.forEach(function (o, k) {
        html += '<button type="button" class="pq-scale__step" role="radio" aria-checked="' + (sel === k) + '" data-k="' + k + '"><span class="pq-key" aria-hidden="true">' + LETTERS[k] + '</span><b>' + esc(o.t) + '</b></button>';
      });
      html += '</div>';
    } else {
      html += '<div class="pq-options' + (q.type === "pair" ? " pq-options--pair" : "") + '" role="radiogroup">';
      q.options.forEach(function (o, k) {
        html += '<button type="button" class="pq-option' + (sel === k ? " is-selected" : "") + '" role="radio" aria-checked="' + (sel === k) + '" data-k="' + k + '">' +
          '<span class="pq-key" aria-hidden="true">' + LETTERS[k] + '</span><span class="pq-option__text"><span class="pq-option__title">' + esc(o.t) + '</span>' +
          (o.h ? '<span class="pq-option__help">' + esc(o.h) + '</span>' : "") + '</span></button>';
      });
      html += '</div>';
    }
    html += '<details class="pq-why"><summary>' + esc(T.why) + ICON_PLUS + '</summary><div class="pq-why__body">' + esc(q.why) +
      '<span class="pq-why__src">' + esc(T.source) + ': ' + esc(q.src) + '</span></div></details>';
    html += privacyBlock("pq-privacy--q");
    host.innerHTML = html;
    host.querySelector('[role="radiogroup"]').setAttribute("aria-label", q.title);
    if (q.type === "scale" && sel != null) paintScale(sel, false);
    host.querySelectorAll("[data-k]").forEach(function (b) { b.addEventListener("click", function (ev) { choose(+b.getAttribute("data-k"), b, ev); }); });
    show("question"); enter(host); Line.render(false);
    setTimeout(function () { var t = host.querySelector(".pq-q__title"); if (t) t.focus({ preventScroll: true }); }, 50);
  }

  function paintScale(k, animate) {
    var fill = screens.question.querySelector(".pq-scale__fill"); if (!fill) return;
    var steps = screens.question.querySelectorAll(".pq-scale__step");
    if (!animate) fill.style.transition = "none";
    fill.style.width = ((k + 1) / steps.length * 100) + "%";
    steps.forEach(function (s, i) {
      s.setAttribute("aria-checked", i === k);
      if (!animate || i > k) { s.classList.toggle("is-under", i <= k); return; }
      setTimeout(function () { s.classList.add("is-under"); }, 520 * (i + 0.6) / (k + 1));
    });
    fill.parentNode.classList.add("has-value");
    if (!animate) { fill.getBoundingClientRect(); fill.style.transition = ""; }
  }

  function choose(k, btn, ev) {
    if (state.locked) return; state.locked = true;
    var q = QUESTIONS[state.i];
    state.answers[state.i] = k;
    var r = btn.getBoundingClientRect();
    var x = ev && ev.clientX ? ev.clientX : r.left + r.width / 2, y = ev && ev.clientY ? ev.clientY : r.top + r.height / 2;
    if (q.type === "scale") paintScale(k, true);
    else screens.question.querySelectorAll(".pq-option").forEach(function (o, i) { o.classList.toggle("is-selected", i === k); o.classList.toggle("is-dim", i !== k); o.setAttribute("aria-checked", i === k); });
    if (!reduced) {
      var bloom = document.createElement("span"); bloom.className = "pq-bloom";
      bloom.style.left = (x - r.left) + "px"; bloom.style.top = (y - r.top) + "px"; btn.appendChild(bloom);
      bloom.animate([{ transform: "translate(-50%,-50%) scale(0)", opacity: 1 }, { transform: "translate(-50%,-50%) scale(" + (Math.max(r.width, r.height) / 5) + ")", opacity: 0 }], { duration: 800, easing: "cubic-bezier(.2,.9,.25,1)" }).onfinish = function () { bloom.remove(); };
      World.ripple(x, y, 1);
      drop(x, y);
    }
    setTimeout(function () { Line.render(true); }, reduced ? 0 : 380);
    setTimeout(next, reduced ? 120 : 560);
  }

  function drop(x, y) {
    var d = document.createElement("span"); d.className = "pq-drop"; root.appendChild(d);
    var to = Line.target(), mx = (x + to[0]) / 2, my = Math.min(y, to[1]) - 60;
    d.animate([
      { transform: "translate(" + x + "px," + y + "px) scale(.4)", opacity: 0 },
      { transform: "translate(" + x + "px," + (y - 10) + "px) scale(1)", opacity: 1, offset: .12 },
      { transform: "translate(" + mx + "px," + my + "px) scale(.9)", opacity: 1, offset: .5 },
      { transform: "translate(" + to[0] + "px," + to[1] + "px) scale(.5)", opacity: .2 }
    ], { duration: 760, easing: "cubic-bezier(.5,0,.3,1)" }).onfinish = function () { d.remove(); };
  }

  function next() {
    state.locked = false;
    if (state.i < COUNT - 1) leave(screens.question, function () { state.i++; renderQuestion(); });
    else leave(screens.question, function () { state.i = COUNT; Line.render(false); show("email"); enter(screens.email); });
  }
  function back() {
    if (screens.email.classList.contains("is-active")) { state.i = COUNT - 1; renderQuestion(); return; }
    if (state.i > 0) leave(screens.question, function () { state.i--; renderQuestion(); });
  }
  if (backBtn) backBtn.addEventListener("click", back);

  /* ---------- start ---------- */
  setIntroScheme(true);
  stage.querySelector("[data-pq-start]").addEventListener("click", function (ev) {
    var r = ev.currentTarget.getBoundingClientRect();
    World.ripple(r.left + r.width / 2, r.top + r.height / 2, 1.6);
    setTimeout(function () { World.ripple(r.left + r.width / 2, r.top + r.height / 2, 1); }, 260);
    World.setDark(0);
    leave(screens.intro, function () { setIntroScheme(false); Line.show(true); state.i = 0; renderQuestion(); });
  });
  (function () {
    var w = screens.intro.querySelector(".pq-intro__spring path"); if (!w || reduced) return;
    var L = w.getTotalLength(); w.style.strokeDasharray = L;
    w.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: 2600, easing: "cubic-bezier(.65,.05,.25,1)", fill: "forwards" });
  })();

  /* ---------- email: Klaviyo, then Meta Lead ---------- */
    function subscribe(email) {
    var company = root.getAttribute("data-klaviyo-company"), list = root.getAttribute("data-klaviyo-list");
    if (!company || !list) return;
    var LOC = window.KALLA_LOCALE;
    fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(company), {
      method: "POST",
      headers: { "Content-Type": "application/vnd.api+json", "revision": "2026-07-15" },
      body: JSON.stringify({ data: { type: "subscription",
        attributes: { custom_source: root.getAttribute("data-source") || "Quiz",
          profile: { data: { type: "profile", attributes: { email: email,
            locale: LOC ? LOC.locale : undefined,
            properties: LOC ? LOC.props() : undefined,
            subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } } },
        relationships: { list: { data: { type: "list", id: list } } } } })
    }).then(function (r) { if (r.ok) trackLead(); }).catch(function () {});
  }
  function trackLead() {
    try {
      if (typeof window.fbq === "function") {
        window.fbq("track", "Lead", { content_name: root.getAttribute("data-source") || "Quiz" },
          { eventID: "quiz-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8) });
      }
    } catch (e) {}
  }
  var form = stage.querySelector("[data-pq-form]"), mailInput = form.querySelector("input"), err = form.querySelector("[data-pq-err]");
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var mail = mailInput.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) { err.textContent = T.emailError; mailInput.focus(); return; }
    err.textContent = ""; state.email = mail;
    subscribe(mail);
    analyse();
  });

  /* ---------- analysing ---------- */
  function analyse() {
    leave(screens.email, function () {
      Line.show(false); show("analysing");
      var svg = screens.analysing.querySelector("svg"), msg = screens.analysing.querySelector(".pq-analysing__msg");
      svg.innerHTML = "";
      var W = 560, mid = 110, seg = W / COUNT;
      for (var g = -3; g <= 3; g++) svgEl("line", { x1: 0, y1: mid + g * 28, x2: W, y2: mid + g * 28, "class": "pq-an__grid" }, svg);
      var bars = state.answers.map(function (a, i) {
        var p = a == null ? 0 : QUESTIONS[i].options[a].p, h = 14 + p * 26, x = seg * i + seg / 2;
        return svgEl("line", { x1: x, x2: x, y1: mid - h, y2: mid + h, "class": "pq-an__bar", style: "transform-origin:" + x + "px " + mid + "px;transform:scaleY(0)" }, svg);
      });
      var wave = svgEl("path", { "class": "pq-an__wave", d: smoothPath(linePoints(state.answers, W, mid, 72)) }, svg);
      var L = wave.getTotalLength(); wave.style.strokeDasharray = L; wave.style.strokeDashoffset = L;
      function say(i) { msg.innerHTML = "<span>" + esc(T.analysing[i]) + "</span>"; }
      say(0);
      if (reduced) { setTimeout(showResult, 600); return; }
      var c = svg.getBoundingClientRect(), cx = c.left + c.width / 2, cy = c.top + c.height / 2;
      bars.forEach(function (b, i) { b.animate([{ transform: "scaleY(0)" }, { transform: "scaleY(1)" }], { duration: 420, delay: i * 90, easing: "cubic-bezier(.2,.9,.25,1)", fill: "forwards" }); });
      wave.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: 1300, delay: 500, easing: "cubic-bezier(.65,.05,.25,1)", fill: "forwards" });
      setTimeout(function () { say(1); World.pulse(); }, 1250);
      setTimeout(function () {
        bars.forEach(function (b, i) { b.animate([{ transform: "scaleY(1)", opacity: 1 }, { transform: "scaleY(0)", opacity: 0 }], { duration: 700, delay: i * 40, easing: "cubic-bezier(.65,.05,.25,1)", fill: "forwards" }); });
        wave.style.transformOrigin = "280px 110px";
        wave.animate([{ transform: "scale(1)", opacity: 1 }, { transform: "scale(1.08,0.2)", opacity: 0 }], { duration: 900, delay: 500, easing: "cubic-bezier(.65,.05,.25,1)", fill: "forwards" });
        [0, 260, 520].forEach(function (d, k) { setTimeout(function () { World.ripple(cx, cy, 1.4 - k * 0.3); }, 700 + d); });
      }, 2050);
      setTimeout(function () { say(2); }, 2700);
      setTimeout(showResult, 3700);
    });
  }

  /* ---------- result ---------- */
  function productCards(keys) {
    var out = document.createElement("div");
    keys.forEach(function (key) {
      var tpl = root.querySelector('template[data-pq-product="' + key + '"]'); if (!tpl) return;
      var node = tpl.content.firstElementChild.cloneNode(true);
      var handle = node.getAttribute("data-handle");
      node.setAttribute("href", HOME + "products/" + handle);
      var line = node.querySelector("[data-line]"); if (line) line.textContent = (T.products && T.products[key]) || "";
      var more = node.querySelector("[data-more]"); if (more) more.textContent = T.readMore;
      out.appendChild(node);
    });
    return out;
  }

  function showResult() {
    var a = state.answers, score = scoreOf(a), band = bandOf(score), R = T.results[band];
    var pms = [], peri = [];
    QUESTIONS.forEach(function (q, i) { if (a[i] == null) return; var s = SIGNALS[q.id] && SIGNALS[q.id][a[i]]; if (!s) return; (s[1] === "pms" ? pms : peri).push(s[0]); });
    var notes = [];
    var ca = CFG.contraceptionAnswer;
    if (ca && a[ca.question] === ca.answer) notes.push(T.contraceptionNote);
    function list(items) {
      if (!items.length) return '<ul><li class="is-empty">' + esc(T.fitsNone) + '</li></ul>';
      return '<ul>' + items.map(function (t, i) { return '<li style="animation-delay:' + (1.1 + i * 0.08).toFixed(2) + 's">' + esc(t) + '</li>'; }).join("") + '</ul>';
    }
    var bounds = CFG.bands.map(function (b) { return Math.min(b.max, CFG.maxScore); });
    var widths = [bounds[0] + 1, bounds[1] - bounds[0], CFG.maxScore - bounds[1]];
    var html = '<div class="pq-result__card">' +
      '<div class="pq-result__top"><a class="pq-close" href="' + esc(HOME) + '">' + esc(T.closePage) + ICON_CLOSE + '</a></div>' +
      '<div class="pq-result__portrait" aria-hidden="true"><svg viewBox="0 0 700 44" preserveAspectRatio="none"></svg></div>' +
      '<h1 class="h1">' + esc(R.title) + '</h1>' +
      '<p class="pq-result__lead">' + esc(R.lead) + '</p>' +
      '<div class="pq-spectrum" role="img" aria-label="' + esc(R.title) + '"><svg viewBox="0 0 600 70" preserveAspectRatio="none"></svg>' +
        '<div class="pq-spectrum__labels" style="grid-template-columns:' + widths.map(function (w) { return w + "fr"; }).join(" ") + '">' +
        ["pms", "mix", "peri"].map(function (k, i) { return '<span class="' + (band === k ? "is-her" : "") + '">' + esc(T.spectrum[i]) + '</span>'; }).join("") + '</div></div>' +
      '<div class="pq-signals">' +
        '<div><h3 class="h6"><svg viewBox="0 0 34 10" aria-hidden="true"><line x1="0" y1="5" x2="34" y2="5"/></svg>' + esc(T.fitsPms) + '</h3>' + list(pms) + '</div>' +
        '<div class="is-peri"><h3 class="h6"><svg viewBox="0 0 34 10" aria-hidden="true"><path d="M0 5 C5 0,8 0,11 5 S17 10,22 5 S29 0,34 5"/></svg>' + esc(T.fitsPeri) + '</h3>' + list(peri) + '</div>' +
      '</div>' +
      '<div class="pq-tip ' + esc(SCHEME_CARD) + '"><h3 class="h6">' + esc(T.tipTitle) + '</h3><p>' + esc(R.tip) + '</p>' +
        notes.map(function (n) { return '<p class="pq-note">' + esc(n) + '</p>'; }).join("") + '</div>' +
      '<div class="pq-products"><h3 class="h6">' + esc(T.productsTitle) + '</h3><div class="pq-products__grid"></div></div>' +
      '<p class="pq-disclaimer">' + esc(T.disclaimer) + '</p>' +
      (state.email ? '<p class="pq-signed">' + esc(T.signedUp) + '</p>' : "") +
      '<div class="pq-result__actions"><button class="btn btn--secondary" type="button" data-pq-retake>' + esc(T.retake) + '</button><a class="btn" href="' + esc(HOME) + '">' + esc(T.goToSite) + '</a></div>' +
      '</div>';
    var host = screens.result; host.innerHTML = html;
    var keys = (CFG.resultProducts && CFG.resultProducts[band]) || [];
    var grid = host.querySelector(".pq-products__grid"), cards = productCards(keys);
    if (cards.children.length) { grid.classList.toggle("is-two", cards.children.length > 1); while (cards.firstChild) grid.appendChild(cards.firstChild); }
    else host.querySelector(".pq-products").remove();
    show("result"); enter(host);
    drawSpectrum(host.querySelector(".pq-spectrum svg"), score, bounds);
    drawPortrait(host.querySelector(".pq-result__portrait svg"));
    host.querySelector("[data-pq-retake]").addEventListener("click", function () {
      state.answers = new Array(COUNT).fill(null); state.i = 0; state.email = null; form.reset();
      Line.build(); Line.show(true); renderQuestion();
    });
  }

  function drawSpectrum(svg, score, bounds) {
    var W = 600, mid = 40, total = CFG.maxScore + 1;
    svgEl("line", { x1: 0, y1: mid, x2: W, y2: mid, "class": "pq-spec__base" }, svg);
    [0, (bounds[0] + 1) / total, (bounds[1] + 1) / total, 1].forEach(function (f) { var x = Math.min(W - .5, Math.max(.5, W * f)); svgEl("line", { x1: x, x2: x, y1: mid - 8, y2: mid + 8, "class": "pq-spec__sep" }, svg); });
    var x = W * ((score + 0.5) / total), pts = [], n = Math.max(8, Math.round(x / 14)), waves = Math.max(1, Math.round(x / 90));
    for (var k = 0; k <= n; k++) { var t = k / n; pts.push([x * t, mid + Math.sin(t * Math.PI * 2 * waves) * 9 * Math.sin(Math.PI * t)]); }
    var her = svgEl("path", { "class": "pq-spec__her", d: smoothPath(pts) }, svg);
    var ring = svgEl("circle", { "class": "pq-spec__ring", cx: x, cy: mid, r: 6, opacity: 0 }, svg);
    var dot = svgEl("circle", { "class": "pq-spec__dot", cx: x, cy: mid, r: 6 }, svg);
    if (reduced) return;
    var L = her.getTotalLength(); her.style.strokeDasharray = L;
    her.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: 1200, delay: 350, easing: "cubic-bezier(.65,.05,.25,1)", fill: "both" });
    dot.animate([{ transform: "translateY(-46px)", opacity: 0 }, { transform: "translateY(-46px)", opacity: 1, offset: .05 }, { transform: "translateY(0)", opacity: 1, offset: .75 }, { transform: "translateY(-6px)", offset: .87 }, { transform: "translateY(0)", opacity: 1 }], { duration: 800, delay: 1350, easing: "cubic-bezier(.5,0,.3,1)", fill: "both" });
    [0, 380, 760].forEach(function (d) { ring.animate([{ r: 6, opacity: .9 }, { r: 34, opacity: 0 }], { duration: 1400, delay: 1950 + d, easing: "cubic-bezier(.2,.9,.25,1)" }); });
    setTimeout(function () { var r = svg.getBoundingClientRect(); World.ripple(r.left + r.width * (x / W), r.top + r.height * (mid / 70), 1.2); }, 1950);
  }

  function drawPortrait(svg) {
    var path = svgEl("path", { d: smoothPath(linePoints(state.answers, 700, 22, 20)) }, svg);
    if (reduced) return;
    var L = path.getTotalLength(); path.style.strokeDasharray = L;
    path.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: 2200, easing: "cubic-bezier(.65,.05,.25,1)", fill: "both" });
  }

  /* ---------- keyboard: A to D or 1 to 4 picks an answer ---------- */
  document.addEventListener("keydown", function (e) {
    if (!screens.question.classList.contains("is-active") || /INPUT|TEXTAREA/.test(e.target.tagName)) return;
    var k = "1234".indexOf(e.key); if (k < 0) k = "abcd".indexOf((e.key || "").toLowerCase());
    var btns = screens.question.querySelectorAll("[data-k]");
    if (k >= 0 && btns[k]) btns[k].click();
  });

  Line.build();
})();